var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VView',{staticClass:"contest-submit",attrs:{"header":_vm.$t('contestSubmit.header')}},[_c('VButton',{on:{"click":function($event){return _vm.submit()}}},[_vm._v(_vm._s(_vm.$t('contestSubmit.submit')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }